import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- @glint-nocheck --}}\n{{#if @show}}\n  <span class=\"form-control-feedback {{@iconName}}\" aria-hidden=\"true\"></span>\n{{/if}}", {
  moduleName: "ember-bootstrap/components/bs-form/element/feedback-icon.hbs"
});